import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetIndividualAdditionalDataResponse } from "./type";

async function getIndividualsData(
  individualId: string,
  query: GetQueries,
): Promise<GetIndividualAdditionalDataResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    const paramKey = String(key) === "individual" ? "search" : key;

    params.append(paramKey, String(value));
  });

  let url = apiPaths.individuals.additionalData.list(individualId);
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response =
    await apiClient.get<GetIndividualAdditionalDataResponse>(url);

  return response.data;
}

export function useGetIndividualAdditionalData(
  individualId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [
      `fetch-get-individuals-additional-data-${individualId}`,
      JSON.stringify(query ?? {}),
    ],
    () => getIndividualsData(individualId, query ?? {}),
    mergedOptions,
  );
}
